import { render } from "./AccountCompanyModal.vue?vue&type=template&id=72dececf"
import script from "./AccountCompanyModal.vue?vue&type=script&lang=ts"
export * from "./AccountCompanyModal.vue?vue&type=script&lang=ts"
script.render = render

export default script